import React from "react";
import { DetailShell } from "@/components/nds/windows/finance/parts";
import SavingsBalanceTab from "@/components/nds/windows/finance/SavingsBalanceTab";
import SavingsRequestsTab from "@/components/nds/windows/finance/SavingsRequestsTab";

const TABS = [
  { id: "balance", label: "Balance", Tab: SavingsBalanceTab, tone: "financial", desc: "Savings balance and recent movements" },
  { id: "requests", label: "Requests", Tab: SavingsRequestsTab, tone: "comms", desc: "Withdrawal requests and their approvals" },
];

export default function FinSavingsDetail({ resident, onBack }) {
  return <DetailShell prefix="fin-savings" tabs={TABS} resident={resident} onBack={onBack} />;
}
